<template>
  <div>
    <headers />
    <div class="content">
      <div class="main">
        <div class="box">
          <div class="login">
            <h3>注册{{seotitle.seo_title}}帐号</h3>
            <div class="item">
              <i class="uname"></i>
              <input type="text" name="uname" placeholder="输入注册手机号" v-model="value" />
            </div>
            <div class="item">
              <i class="code"></i>
              <input class="fl text" type="text" name="uname" placeholder="输入验证码" v-model="sms" />
              <div class="fl timebs">
                <div class="stars" @click="start">
                  <em v-show="xian==0">获取验证码</em>
                  <em v-show="xian==2">重新获取</em>
                </div>
                <van-count-down
                  ref="countDown"
                  :time="time"
                  format=" ss 秒"
                  @pause="pause"
                  @reset="reset"
                  @finish="finish"
                  :auto-start="false"
                  v-show="xian==1"
                >
                  <template v-slot="timeData">
                    <div class="itemsss">{{ timeData.seconds }}s</div>
                  </template>
                </van-count-down>
              </div>
            </div>
            <div class="item">
              <i class="nickname"></i>
              <input type="text" name="nickname" placeholder="输入昵称" v-model="nickname" />
            </div>
            <div class="item">
              <i class="pwd"></i>
              <input type="password" name="uname" placeholder="设置新密码" v-model="password" />
            </div>
            <div class="item">
              <i class="pwd"></i>
              <input type="password" name="uname" placeholder="再次确认密码" v-model="password_nows" />
            </div>
            <div class="btn" @click="register">注 册</div>
            <div class="ems">
              <el-checkbox v-model="checked"></el-checkbox>我已同意
              <em @click="xieyi">《{{seotitle.seo_title}}用户协议》</em>
            </div>
          </div>
          <div class="notice">
            已有账号？
            <router-link tag="a" to="/logins">直接登录</router-link>
          </div>
        </div>
      </div>
    </div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import { CountDown } from "vant";
import { Checkbox, Message } from "element-ui";
import utilFile from "@/ace/ace.js";
export default {
  components: {
    headers,
    footers,
    [CountDown.name]: CountDown,
    [Checkbox.name]: Checkbox,
    [Message.name]: Message
  },
  data() {
    return {
      value: null,
      nickname:null,
      sms: null,
      password: null,
      password_nows: null,
      classname: " ",
      checked: false,
      time: 60 * 1000,
      xian: 0,
      agreeUrl: "",
      seotitle:{},
    };
  },
  methods: {
    xieyi() {
      this.$axios({
        method: "post",
        url: `/api/home.configure`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        this.agreeUrl = JSON.parse(utilFile.decrypt(res.data.data)).agreeUrl;
        window.location.href = this.agreeUrl;
      });
    },
    start() {
      if (this.value != null) {
        let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

        if (myreg.test(this.value)) {
          var data = utilFile.encrypt(
            JSON.stringify({
              phone: this.value,
              purpose: 1 //1注册，2忘记密码，3支付密码
            })
          );

          this.$axios({
            method: "post",
            url: `/api/authority.getcode?parameter=${data}`,
            data: {},
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
          }).then(res => {
            if (res.data.code == 200) {
              this.$refs.countDown.start();
              this.xian = 1;
              Message.closeAll();
              Message({
                showClose: true,
                message: res.data.msg,
                type: "success"
              });
            } else {
              Message.closeAll();
              Message({
                showClose: true,
                message: res.data.msg,
                type: "error"
              });
            }
          });
        } else {
          Message.closeAll();
          Message({
            showClose: true,
            message: "手机格式不正确",
            type: "warning"
          });
        }
      } else {
        Message.closeAll();
        Message({
          showClose: true,
          message: "请填写手机号",
          type: "warning"
        });
      }
    },
    pause() {
      this.$refs.countDown.pause();
    },
    reset() {
      this.$refs.countDown.reset();
    },
    finish() {
      this.xian = 2;
      //this.$toast('倒计时结束');
      this.reset();
    },
    register() {
      console.log("aaa");
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      console.log(this.value, this.sms, this.password, this.password_nows);
      if (
        this.value != null &&
        this.sms != null &&
        this.password != null &&
        this.password_nows != null
      ) {
        if (myreg.test(this.value)) {
          if (this.password == this.password_nows) {
            if (this.checked) {
              /*注册开始*/
              var data = utilFile.encrypt(
                JSON.stringify({
                  phone: this.value,
                  code: this.sms,
                  pwd: this.password,
                  nickname:this.nickname,
                  invite_code: this.$route.query.invite_code
                })
              );
              this.$axios({
                method: "post",
                url: `/api/authority.register?parameter=${data}`,
                data: {},
                withCredentials: true,
                headers: {
                  "Content-Type":
                    "application/x-www-form-urlencoded; charset=UTF-8"
                }
              }).then(res => {
                if (res.data.code == 200) {
                  Message.closeAll();
                  Message({
                    showClose: true,
                    message: res.data.msg,
                    type: "success"
                  });
                  localStorage.setItem("mobile", this.value); //缓存帐号 设置支付密码使用
                  setTimeout(() => {
                    this.$router.replace({
                      path:'/index'
                    })
                  }, 1000);
                } else {
                  Message.closeAll();
                  Message({
                    showClose: true,
                    message: res.data.msg,
                    type: "success"
                  });
                }
              });

              /*end*/
            } else {
              Message.closeAll();
              Message({
                showClose: true,
                message: "请阅读或者勾选协议",
                type: "warning"
              });
            }
          } else {
            Message.closeAll();
            Message({
              showClose: true,
              message: "两次密码不一致",
              type: "error"
            });
          }
        } else {
          Message.closeAll();
          Message({
            showClose: true,
            message: "手机号码格式不正确",
            type: "error"
          });
        }
      } else {
        Message.closeAll();
        Message({
          showClose: true,
          message: "不能为空",
          type: "error"
        });
      }
    },
    titlefunc() {
      this.$axios({
        method: "post",
        url: `/api/home.config`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let data = JSON.parse(utilFile.decrypt(res.data.data));
        this.seotitle = data;
      });
    },
  },
  mounted(){
    this.titlefunc();
  }
};
</script>

<style scoped>
.content {
  width: 100%;
  height: 620px;
  background-image: url("~@/assets/images/login_bg.jpg");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% 100%;
  position: relative;
  cursor: pointer;
  margin-top: 80px;
  margin-bottom: 166px;
}

.content .main {
  width: 380px;
  background-color: #fff;
  border-radius: 10px 10px;
  margin: 0px auto;
  position: absolute;
  left: 50%;
  margin-left: -190px;
  top: 50%;
  margin-top: -240px;
  box-shadow: 0px 0px 5px rgba(242, 243, 245, 0.6);
  overflow: hidden;
}
.content .main .box {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1000;
}
.content .main .box .notice {
  width: 100%;
  height: 60px;
  text-align: center;
  font-size: 16px;
  line-height: 60px;
  color: #000;
  background-color: #f9fafc;
}
.content .main .box .notice a {
  color: #379dff;
}
.content .main .login {
  padding: 80px 30px 0;
  padding-top: 37px;
  box-shadow: 0 0 6px 0 rgba(0,0,0,0.1);
  padding-bottom: 1px;
  position: relative;
  z-index: 100;
}

.content .main .login .item {
  width: 100%;
  border: 1px solid #d9dde1;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 20px;
  border-radius: 5px 5px;
  overflow: hidden;
}

.content .main .login .item.zhmm {
  text-align: right;
  font-size: 14px;
  line-height: 40px;
  color: #bababa;
  border: 0px;
}

.content .main .login .item input {
  height: 40px;
  border: 0px;
  width: 250px;
  float: left;
}

.content .main .login .item i.uname {
  width: 40px;
  height: 40px;
  display: inline-table;
  float: left;
  background-image: url("~@/assets/images/ico1.png");
  background-repeat: no-repeat;
  background-position: center center;
}

.content .main .login .item i.pwd {
  width: 40px;
  height: 40px;
  display: inline-table;
  float: left;
  background-image: url("~@/assets/images/ico2.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.content .main .login .item i.nickname {
    width: 40px;
    height: 40px;
    display: inline-table;
    float: left;
    background-image: url("~@/assets/images/ico3.png");
    background-repeat: no-repeat;
    background-position: center center;
}
.content .main .login .item i.code {
  width: 40px;
  height: 40px;
  display: inline-table;
  float: left;
  background-image: url("~@/assets/images/code_03.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.content .main .login .btn {
  width: 100%;
  height: 43px;
  line-height: 43px;
  background-image: linear-gradient(
    to right,
    rgba(53, 145, 255, 1),
    rgba(63, 196, 254, 1)
  );
  border: 0px;
  border-radius: 21px 21px;
  font-size: 16px;
  color: #fff;
}

.content .main .login h3 {
  text-align: center;
  font-size: 20px;
  color: #38a0ff;
  margin-bottom: 40px;
}

.baofooter {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
}
.content .main .login .item input.text {
  width: 208px;
}

.timebs {
  position: relative;
}

.content .main .login .item .stars {
  width: 68px;
  line-height: 26px;
  height: 26px;
  border: 1px solid #3aacfe;
  text-align: center;
  border-radius: 6px;
  font-size: 12px;
  margin-top: 6px;
}

.itemsss {
  line-height: 26px;
}

.ems {
  margin-top: 18px;
  margin-bottom: 30px;
}

.ems em {
  color: #379dff;
}
</style>
<style>
.content .main .login .item .van-count-down {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  border: 0;
  padding: 0;
  line-height: 26px;
  padding-top: 6px;
  box-sizing: border-box;
}

.ems .el-checkbox{
  margin-right: 8px;
}
</style>